import { render, staticRenderFns } from "./ActivateMessage.vue?vue&type=template&id=1d453a99&scoped=true&lang=pug&"
import script from "./ActivateMessage.vue?vue&type=script&lang=ts&"
export * from "./ActivateMessage.vue?vue&type=script&lang=ts&"
import style0 from "./ActivateMessage.vue?vue&type=style&index=0&id=1d453a99&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d453a99",
  null
  
)

export default component.exports